import { get as getLocalStorage, set as setLocalStorage } from 'lib/storage/isomorphicLocalStorage'
import { SEARCH_STORAGE_KEYS } from 'constants/search'
import { DurationMs } from 'lib/datetime/durationInSeconds'

export const FAMILY_SEARCH_WINDOW_MS = DurationMs.THIRTY_DAYS

export function getLatestFamilySearchTimestamp(
  searches: ReadonlyArray<{ timestamp: string, hasChildren: boolean }>,
  now: number,
): number | undefined {
  let latest: number | undefined
  for (const search of searches) {
    const timestamp = Date.parse(search.timestamp)
    if (search.hasChildren && Number.isFinite(timestamp) && timestamp <= now
      && timestamp >= now - FAMILY_SEARCH_WINDOW_MS) {
      latest = Math.max(latest ?? timestamp, timestamp)
    }
  }
  return latest
}

// Keep submission evidence separately from the destination-deduplicated recent
// searches. An adults-only search or removal from that display list cannot erase it.
export function getSavedFamilySearchTimestamp(userKey?: string): number | undefined {
  if (!userKey) return undefined
  const value: unknown = getLocalStorage(`${userKey}.${SEARCH_STORAGE_KEYS.FAMILY_SEARCH_INTENT}`)
  if (typeof value !== 'number' || !Number.isFinite(value)) return undefined
  return hasRecentFamilySearch(value, Date.now()) ? value : undefined
}

export function rememberFamilySearchTimestamp(timestamp: number | undefined, userKey?: string) {
  if (!userKey || timestamp === undefined) return
  const previous = getSavedFamilySearchTimestamp(userKey)
  if (previous === undefined || timestamp > previous) {
    setLocalStorage(`${userKey}.${SEARCH_STORAGE_KEYS.FAMILY_SEARCH_INTENT}`, timestamp)
  }
}

export function hasRecentFamilySearch(timestamp: number | undefined, now: number): boolean {
  return timestamp !== undefined && timestamp <= now && timestamp >= now - FAMILY_SEARCH_WINDOW_MS
}
